<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-card-title>
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.serial"
                label="顧客コード"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.name"
                label="客先名"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.office"
                label="営業所"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['name']"
          :sort-desc="[true]"
          :loading="loading"
          @click:row="onRowClick">
            <template v-slot:item.address="{ item }">
              〒{{ item.post }} {{ item.pref }}{{ item.address }} {{ item.build }}
            </template>
            <template v-slot:item.closing="{ item }">
              <template v-if="item.closing != null">
                {{ item.closing == 0 ? '末日' : item.closing + '日' }}
              </template>
              <template v-else>
                ---
              </template>
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog">
        <v-card flat class="drawer-card">
          <v-card-title>
            <div class="title">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</div>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="email"
                    label="e-mail"
                    type="email"
                    v-model="editedItem.email"
                    :rules="[rules.email, existsEmail]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="passwd"
                    label="パスワード"
                    type="password"
                    v-model="editedItem.passwd"
                    :rules="[rules.min8Char]"
                    autocomplete="passwd"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="serial"
                    label="顧客コード"
                    v-model="editedItem.serial"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="8" class="pa-2">
                  <v-combobox
                    ref="name"
                    label="客先名"
                    v-model="editedItem.name"
                    :items="company"
                    :rules="[rules.required]"
                    class="required"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('name', true)"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="8" class="pa-2">
                  <v-text-field
                    ref="office"
                    label="営業所"
                    v-model="editedItem.office"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="charge"
                    label="客先担当"
                    v-model="editedItem.charge"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="post"
                    label="郵便番号"
                    v-model="editedItem.post"
                    prefix="〒"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="8" class="pa-2">
                  <v-combobox
                    ref="pref"
                    label="都道府県"
                    v-model="editedItem.pref"
                    :items="prefs"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('pref')"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="address"
                    label="住所"
                    v-model="editedItem.address"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="build"
                    label="ビル・建物等"
                    v-model="editedItem.build"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="tel"
                    label="電話番号(ハイフンあり)"
                    type="tel"
                    v-model="editedItem.tel"
                    :rules="[rules.tel]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="fax"
                    label="FAX番号(ハイフンあり)"
                    type="tel"
                    v-model="editedItem.fax"
                    :rules="[rules.tel]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="url"
                    label="URL"
                    v-model="editedItem.url"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-swatches v-model="editedItem.color" swatches="text-advanced" :spacing-size="0">
                    <v-text-field
                      ref="color"
                      label="色"
                      slot="trigger"
                      :background-color="editedItem.color"
                      v-model="editedItem.color"
                      readonly outlined hide-details="auto">
                    </v-text-field>
                  </v-swatches>
                </v-col>
                <v-col cols="8" class="pa-2">
                  <v-combobox
                    ref="agencyID"
                    label="代理店"
                    v-model="editedItem.agencyID"
                    :items="agency"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('agencyID')"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox
                    ref="payment"
                    label="支払方法"
                    v-model="editedItem.payment"
                    :items="payment"
                    :rules="[rules.required, rules.arrayEmpty]"
                    class="required"
                    multiple small-chips outlined hide-details="auto">
                    <template v-slot:selection="{ item, parent, selected }">
                      <v-chip :input-value="selected" label small color="primary">
                        <span class="pr-2">{{ item }}</span>
                        <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-combobox
                    ref="closing"
                    label="締め日"
                    v-model="editedItem.closing"
                    :items="closing"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('closing')"
                    readonly outlined hide-details>
                  </v-combobox>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="rate"
                    label="卸値の掛け率"
                    type="number"
                    min="0"
                    max="100"
                    v-model="editedItem.rate"
                    :rules="[rules.min0, rules.max100]"
                    append-icon="fas fa-percentage"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-combobox
                    ref="salesID"
                    label="営業担当"
                    v-model="editedItem.salesID"
                    :items="users"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('salesID')"
                    readonly outlined hide-details clearable>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createCustomer, updateCustomer, deleteCustomer } from '../graphql/mutations'
import { listCustomers, listUsers } from '../graphql/queries'
import { onCreateCustomer, onUpdateCustomer, onDeleteCustomer } from '../graphql/subscriptions'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '顧客コード', align: 'start', value: 'serial' },
        { text: '客先名', align: 'start', value: 'name' },
        { text: '営業所', align: 'start', value: 'office' },
        { text: '電話番号', align: 'start', value: 'tel' },
        { text: 'e-mail', align: 'start', value: 'email' },
        { text: '締め日', align: 'end', value: 'closing' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      users: [],
      editedIndex: -1,
      editedItem: {
        payment: [],
      },
      filterKeyword: {},
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    await this.getCustomers()
    //アカウント query
    await this.getUsers()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateCustomer
        this.desserts.push(data)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateCustomer
        this.desserts.find(origin => {
          if (origin.id === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteCustomer
        this.desserts = this.desserts.filter(origin => origin.id !== data.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //顧客コード
        if (this.filterKeyword.serial && (!item.serial || item.serial.indexOf(this.filterKeyword.serial) < 0)) continue
        //会社名
        if (this.filterKeyword.name && item.name.indexOf(this.filterKeyword.name) < 0) continue
        //営業所
        if (this.filterKeyword.office && (!item.office || item.office.indexOf(this.filterKeyword.office) < 0)) continue
        map.push(item)
      }
      return map
    },
    existsEmail() {
      if (this.editedItem.email) {
        const user = this.desserts.find(e => e.email === this.editedItem.email)
        return (!user || user.id == this.editedItem.id) || 'このメールアドレスは使用されています'
      } else {
        return true;
      }
    },
    company() {
      const map = []
      this.desserts.forEach(e => {
        if (!map.find(m => m === e.name)) map.push(e.name)
      })
      return map
    },
    agency() {
      const map = []
      this.desserts.forEach(e => {
        map.push({
          value: e.id,
          text: e.name + (e.office ? '（' + e.office + '）' : ''),
        })
      })
      return map
    },
    closing() {
      const map = []
      for (let i=1; i<=28; i++) {
        map.push({ value: i, text: i + '日' })
      }
      map.push({ value: 0, text: '末日' })
      return map
    },
    form() {
      return {
        id: this.editedItem.id || null,
        serial: this.editedItem.serial || null,
        name: this.editedItem.name || null,
        office: this.editedItem.office || null,
        email: this.editedItem.email || null,
        passwd: this.editedItem.passwd || null,
        post: this.editedItem.post || null,
        pref: this.editedItem.pref || null,
        address: this.editedItem.address || null,
        build: this.editedItem.build || null,
        tel: this.editedItem.tel || null,
        fax: this.editedItem.fax || null,
        url: this.editedItem.url || null,
        agencyID: this.editedItem.agencyID ? this.editedItem.agencyID.value: null,
        closing: this.editedItem.closing ? this.editedItem.closing.value: null,
        payment: this.editedItem.payment || [],
        rate: this.editedItem.rate || null,
        charge: this.editedItem.charge || null,
        salesID: this.editedItem.salesID ? this.editedItem.salesID.value: null,
        color: this.editedItem.color || null,
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //行選択
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      //email
      if (!this.editedItem.email) delete this.editedItem.email
      //passwd
      if (!this.editedItem.passwd) delete this.editedItem.passwd
      //代理店
      this.editedItem.agencyID = this.agency.find(e => e.value === this.editedItem.agencyID) || null
      //締め日
      this.editedItem.closing = this.closing.find(e => e.value === this.editedItem.closing) || null
      //営業担当
      this.editedItem.salesID = this.users.find(e => e.value === this.editedItem.salesID) || null
      this.dialog = true
    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = Object.assign({}, this.form)
        //編集
        if (this.editedIndex >= 0) {
          await API.graphql(graphqlOperation(updateCustomer, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を更新しました' })
        //新規
        } else {
          delete data.id
          await API.graphql(graphqlOperation(createCustomer, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を追加しました' })
        }
        this.dialog = false
      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.name + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteCustomer, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.editedItem.name + '] を削除しました' })
          this.myAlert(this.editedItem.name + 'を削除しました', 'success')
          this.dialog = false
        }
      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f]) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.payment = []
      //this.editedItem.color = null
      delete this.editedItem.email
      delete this.editedItem.passwd
    },
    //フルネーム
    getFullname(user) {
      return user.last + ' ' + user.first
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.desserts.push(data)
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users.push({
          value: data.id,
          text: data.last + data.first,
        })
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
  },
  components: {
    VSwatches,
  },
}
</script>

<style lang='scss' scoped>

</style>
